const MEDIA_URL_FIELDS = [
  'thumbnailPath',
  'compressedMediaPath',
  'mediaPath',
  'url',
  'path',
  'publicUrl',
  'secureUrl',
] as const;

function cleanUrl(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed || undefined;
}

export function pickMediaValue(value: unknown): string | undefined {
  const direct = cleanUrl(value);
  if (direct) return direct;

  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined;
  }

  const media = value as Record<string, unknown>;
  for (const field of MEDIA_URL_FIELDS) {
    const url = cleanUrl(media[field]);
    if (url) return url;
  }

  return undefined;
}

export function pickMediaUrl(
  source: Record<string, unknown> | null | undefined,
  ...keys: string[]
): string | undefined {
  if (!source) return undefined;

  for (const key of keys) {
    const url = pickMediaValue(source[key]);
    if (url) return url;
  }

  return undefined;
}
